/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";

// components
import PopupSelect from "../ui/popup/Select";

// hooks
import useDidMountEffect from "hooks/useDidMountEffect";

// assets
import iconDrop from "assets/icons/icon_drop_blue.svg";

export const BottomBranchSelect = ({ searchBranch, onChange }) => {
  const {
    seqPartner,
    partnerList,
    partnerName,
    headquarterYn,
    seqPartnerBranch,
  } = useSelector((state) => state.partner);
  if (!(headquarterYn === "Y" && seqPartnerBranch === 0)) return null;

  const [branch, setBranch] = useState(searchBranch);

  useEffect(() => {
    if (onChange) onChange(branch);
  }, [branch]);

  useDidMountEffect(() => {
    if (searchBranch) {
      setBranch(searchBranch);
    }
  }, [searchBranch]);

  const branchList =
    (partnerList.filter((item) => item.seqPartner == seqPartner)[0] || {})
      .partnerBranches || [];

  /**
   * 로그인 정보가 useBranchYn="Y" and headquarter="Y"가 아닌 경우 리턴
   * 지점 목록이 한 개 이하인 경우 리턴
   */

  const eventHandler = {
    changeBranch: (name, value) => {
      setBranch(Number(value));
    },
  };

  const getBranchName = () => {
    const branchInfo =
      branchList.filter((item) => item.seqPartnerBranch === branch)[0] || {};
    return (
      branchInfo.branchName || branchInfo.partnerName || `${partnerName} : 전체`
    );
  };

  const getOptionList = () => {
    const options = branchList.map((item) => {
      return {
        value: item.seqPartnerBranch,
        label: item.branchName || item.partnerName,
      };
    });
    return options;
  };

  return (
    <Wrapper>
      <div className="dummy" />
      <div className="button">
        <PopupSelect
          isIcon={true}
          isBlock={true}
          value={branch}
          title="지점선택"
          options={getOptionList()}
          onChange={eventHandler.changeBranch}
        >
          {getBranchName()}
        </PopupSelect>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  .dummy {
    height: calc(50px + 40px);
  }
  .button {
    position: fixed;
    bottom: 40px;
    left: 24px;
    right: 24px;
    height: 52px;
    background-color: white;
    border-radius: 52px;
    border: none;
    box-shadow: 0px 1px 20px rgba(80, 96, 154, 0.2);
    font-size: var(--18px);
    font-weight: 600;
    color: var(--blue);
    z-index: 2;
  }
  .button > div > div {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
  }
  .button > div > div:after {
    margin: 2px 0 0 2px;
    background: url(${iconDrop}) no-repeat center center / 0.7em;
  }
`;

export default BottomBranchSelect;
